import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React, { createContext, useReducer, useEffect } from 'react';
import { initialState, reducer } from './reducer';
export var AppConfigDispatchContext = createContext(undefined);
export var AppConfigStateContext = createContext(undefined);
export var AppConfigProvider = function AppConfigProvider(_ref) {
  var children = _ref.children,
      seed = _objectWithoutPropertiesLoose(_ref, ["children"]);

  var _useReducer = useReducer(reducer, _extends({}, initialState, seed)),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  var pageTitle = state.pageTitle,
      appName = state.appName;
  useEffect(function () {
    var t = pageTitle ? ' - ' : '';
    document.title = pageTitle + t + appName;
  }, [pageTitle, appName]);
  return React.createElement(AppConfigDispatchContext.Provider, {
    value: dispatch
  }, React.createElement(AppConfigStateContext.Provider, {
    value: state
  }, children));
};
AppConfigProvider.defaultProps = {
  appName: 'SRIN Web UI'
};